import { IFertilisersDto } from "../dtos/fertilisers";
import { Units } from "../enums/units";

export class Fertiliser {
  readonly id: string;
  name: string;
  type: string;
  unit: (typeof Units)[keyof typeof Units];
  units?: string[];
  isDeleted?: boolean;

  constructor(id: string) {
    this.id = id;
  }

  get asDto(): IFertilisersDto {
    return {
      id: this.id,
      name: this.name,
      type: this.type,
      unit: this.unit,
      units: this.units,
    };
  }

  updateFromDto(dto: IFertilisersDto): void {
    this.name = dto.name;
    this.type = dto.type;
    this.unit = dto.unit;
    this.units = dto.units;
    this.isDeleted = dto.isDeleted;
  }

  clone(): Fertiliser {
    return Object.assign(new Fertiliser(this.id), this);
  }
}
